import { render } from "./NavBar.vue?vue&type=template&id=46082a86&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=46082a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46082a86"]])

export default __exports__